<div class="page-container">
  <app-card>
    <app-card-header>
      <app-card-title>{{ 'reports.funnel.title' | translate }}</app-card-title>
    </app-card-header>
    <app-card-content>
      <app-report-filter-bar [includeAllUsers]="includeAllUsers" (filtersChange)="onFiltersChange($event)" />

      @if (loading()) {
        <div class="loading-container flex flex-column flex-align-center p-lg no-print">
          <app-spinner />
        </div>
      } @else if (stages().length === 0) {
        <p class="empty-state" data-testid="funnel-empty">{{ 'reports.funnel.empty' | translate }}</p>
      } @else {
        <ul class="funnel-list" data-testid="funnel-list">
          @for (stage of stages(); track stage.stage) {
            <li class="funnel-stage" [attr.data-testid]="'funnel-stage-' + stage.stage">
              <span class="funnel-stage-name">{{ ('reports.funnel.stage.' + stage.stage) | translate }}</span>
              <span class="funnel-stage-count">{{ stage.count }}</span>
              @if (stage.percentOfPrevious !== null) {
                <span class="funnel-stage-detail">{{ 'reports.funnel.ofPrevious' | translate: { pct: (stage.percentOfPrevious * 100).toFixed(1) } }}</span>
              }
              <span class="funnel-stage-detail">{{ 'reports.funnel.ofTotal' | translate: { pct: (stage.percentOfTotal * 100).toFixed(1) } }}</span>
            </li>
          }
        </ul>
      }
    </app-card-content>
    <app-card-actions class="no-print">
      <app-button variant="outlined" (click)="print()" data-testid="print-button">
        <app-icon name="printer" [size]="16" />
        {{ 'reports.funnel.print' | translate }}
      </app-button>
    </app-card-actions>
  </app-card>
</div>
